export default __webpack_public_path__ + "static/media/signin-persona-gov-security.1e5bd281.svg";